import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-time-entry-header',
  templateUrl: './time-entry-header.component.html',
  styleUrls: ['./time-entry-header.component.scss'],
})
export class TimeEntryHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() isDeleteDisabled: boolean;
  @Input() isSaveDisabled: boolean;

  // Let the parent own the source of truth via [(view)] banana-in-a-box,
  // instead of duplicating 'grid'/'calendar' state in two places.
  @Input() view: 'grid' | 'calendar' = 'grid';
  @Output() viewChange = new EventEmitter<'grid' | 'calendar'>();

  @Output() newClicked = new EventEmitter<void>();
  @Output() saveClicked = new EventEmitter<void>();
  @Output() deleteClicked = new EventEmitter<void>();
  @Output() resetClicked = new EventEmitter<void>();

  isSmallScreenFlag: boolean;
  isLargeScreenFlag: boolean;

  constructor() {
    this.isSmallScreenFlag = false;
    this.isLargeScreenFlag = false;
  }

  ngOnInit(): void {
    this.checkScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isSmallScreenFlag = window.innerWidth < 768;
    this.isLargeScreenFlag = !this.isSmallScreenFlag;
  }

  isSmallScreen(): boolean {
    return this.isSmallScreenFlag;
  }

  isLargeScreen(): boolean {
    return this.isLargeScreenFlag;
  }

  setView(view: 'grid' | 'calendar'): void {
    this.view = view;
    this.viewChange.emit(view);
  }
}